import React from 'react';
import classNames from 'classnames';

interface SwitchProps {
  checked: boolean;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
  inverse?: boolean;
}

const Switch = ({ checked, onChange, disabled, inverse }: SwitchProps) => {
  const value = inverse ? !checked : checked || false;

  const className = classNames({
    switch: true,
    'switch--checked': value,
    'switch--disabled': disabled,
  });

  const onClick = (e) => {
    if (disabled) return;
    onChange(inverse ? !e.target.checked : e.target.checked);
  };

  return (
    <label className={className}>
      <input type="checkbox" checked={value} onChange={onClick} />
      <div className="switch__path" />
      <span className="switch__toggle" />
    </label>
  );
};

export default Switch;
